export default "__VITE_ASSET__C$0I8wbt__"